export const ACTION_CODE = 'ACTIVITY_TYPES' + '_ACTION';
